<template>
	<v-dialog
		v-model="dialog"
		max-width="700px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				class="ml-2"
				:text="text"
				:color="text ? 'white' : 'secondary'"
				@click.stop="dialog = true"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-2">mdi-magnify</v-icon>
				検索
			</v-btn>
		</template>

		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">検索</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-card-text class="pa-2">
				<v-form ref="form">
					<v-select
						label="並び替え"
						v-model="q.sorts"
						class="mt-4"
						:items="sortOptions"
						item-value="id"
						item-text="name"
						outlined
						dense
						clearable
					/>
					<v-text-field
						label="製造番号"
						v-model="q.ordered_product_product_number_cont"
						class="mt-4"
						outlined
						dense
					/>
					<v-text-field
						label="製品名または製品番号"
						v-model="q.ordered_product_product_name_or_matter_product_product_name_cont"
						class="mt-4"
						outlined
						dense
					/>
					<v-select
						label="製品カテゴリー"
						v-model="
							q.ordered_product_product_product_category_id_or_matter_product_product_product_category_id_eq
						"
						:items="categories"
						item-text="name"
						item-value="id"
						class="mt-4"
						outlined
						clearable
						dense
						@change="changeCategoryId"
					/>
					<v-select
						label="製品サブカテゴリー"
						v-model="
							q.ordered_product_product_product_sub_category_id_or_matter_product_product_product_sub_category_id_eq
						"
						:items="setSubCategories"
						item-text="name"
						item-value="id"
						class="mt-4"
						outlined
						clearable
						:no-data-text="
							q.ordered_product_product_product_category_id_or_matter_product_product_product_category_id_eq
								? 'データが見つかりません。'
								: '製品カテゴリーを選択してください。'
						"
						dense
					/>
					<v-select
						label="工程"
						v-model="q.large_processes_large_process_type_id_eq"
						:items="largeProcessTypes"
						item-text="name"
						item-value="id"
						class="mt-4"
						outlined
						clearable
						dense
						hint="指定した工程を持つ製品のみを絞り込みます。"
					/>

					<v-menu
						ref="deadlineRangeMenu"
						v-model="deadlineRangeMenu"
						:close-on-content-click="false"
						:return-value.sync="deadlineRange"
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="deadlinesText"
								label="納期"
								class="mt-4"
								clearable
								outlined
								dense
								readonly
								v-bind="attrs"
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker
							class="date-picker"
							v-model="deadlineRange"
							no-title
							scrollable
							range
							locale="ja-JP"
						>
							<v-spacer />
							<v-btn text color="primary" @click="deadlineRangeMenu = false"> キャンセル </v-btn>
							<v-btn
								text
								color="primary"
								@click="changeDateRange('deadlineRange', 'delivery_info_deadline')"
							>
								決定
							</v-btn>
						</v-date-picker>
					</v-menu>
					<v-radio-group v-model="q.ordered_product_id_not_null" row>
						<v-radio label="未受注品を含む" :value="''"></v-radio>
						<v-radio label="未受注品を含まない" :value="true"></v-radio>
					</v-radio-group>
					<v-radio-group v-model="q.status_in" row>
						<v-radio label="完成済みを含む" :value="[]"></v-radio>
						<v-radio
							label="完成済みを含まない"
							:value="['pending', 'order_received', 'manufacture_started']"
						></v-radio>
					</v-radio-group>
					<v-checkbox label="工程がない製品を含まない" v-model="q.large_processes_id_not_null" :value="true" />
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-row no-gutters>
					<v-col cols="0" sm="2"></v-col>
					<v-col cols="12" sm="8">
						<v-row class="ma-0 pa-0" justify="center">
							<v-btn class="ma-1" @click="searchItems" color="secondary">
								<v-icon class="mr-2">mdi-magnify</v-icon>
								検索</v-btn
							>
							<v-btn class="ma-1" @click="resetForm" outlined color="secondary">
								<v-icon class="mr-2">mdi-autorenew</v-icon>
								クリア</v-btn
							>
						</v-row>
					</v-col>
					<v-col cols="0" sm="2">
						<v-row v-if="!$vuetify.breakpoint.xs" no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="dialog = false"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import common from "../../../helper/common"
export default {
	props: {
		query: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		categories: {
			type: Array,
			required: false,
			default: () => [],
		},
		largeProcessTypes: {
			type: Array,
			required: false,
			default: () => [],
		},
		text: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			common,
			dialog: false,
			deadlineRange: [],
			shippingDateRange: [],
			deadlineRangeMenu: false,
			shippingDateRangeMenu: false,
			sortOptions: [
				{ id: "created_at desc", name: "物件入力日が新しい順" },
				{ id: "created_at asc", name: "物件入力日が古い順" },
			],
		}
	},
	mounted() {
		if (this.q.delivery_info_deadline_gteq)
			this.deadlineRange.push(this.q.delivery_info_deadline_gteq)
		if (this.q.delivery_info_deadline_lteq)
			this.deadlineRange.push(this.q.delivery_info_deadline_lteq)
	},
	methods: {
		searchItems() {
			this.$emit("search-items", this.q)
			this.dialog = false
		},
		resetForm() {
			this.$refs.form.reset()
		},
		changeCategoryId() {
			this.q.ordered_product_product_product_sub_category_id_or_matter_product_product_product_sub_category_id_eq =
				null
		},
		changeDateRange(dateRange, queryName) {
			if (this[dateRange].length) {
				const firstDate = this[dateRange][0]
				const lastDate = this[dateRange][this[dateRange].length - 1]
				if (firstDate > lastDate) {
					this.q[`${queryName}_gteq`] = lastDate + "T00:00:00+09:00"
					this.q[`${queryName}_lteq`] = firstDate + "T23:59:59+09:00"
				} else {
					this.q[`${queryName}_gteq`] = firstDate + "T00:00:00+09:00"
					this.q[`${queryName}_lteq`] = lastDate + "T23:59:59+09:00"
				}
			} else {
				this.q[`${queryName}_gteq`] = null
				this.q[`${queryName}_lteq`] = null
			}
			this.$refs[`${dateRange}Menu`].save(this[dateRange])
		},
	},
	computed: {
		q: {
			get() {
				return this.query
			},
			set(newValue) {
				return this.$emit("update:q", newValue)
			},
		},
		deadlinesText: {
			get() {
				return this.deadlineRange.length
					? this.deadlineRange.map((d) => common.formatDate(d)).join(" ~ ")
					: null
			},
			set(newVal) {
				this.deadlineRange = []
				this.changeDateRange("deadlineRange", "created_at")
				return
			},
		},
		setSubCategories() {
			const categoryId =
				this.q
					.ordered_product_product_product_category_id_or_matter_product_product_product_category_id_eq
			if (!categoryId) {
				return []
			} else {
				const category = this.categories.find((c) => c.id == categoryId)
				if (!category) return []
				return category.product_sub_categories
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
	margin-top: 0;
}
</style>